/**
 * Submit an input's form whenever its value changes. This lets a `<select>` that
 * reloads the page act without a separate submit button when JavaScript is
 * available; provide a fallback submit button inside `<noscript>` for when it
 * isn't.
 *
 * Example:
 *    <form method="GET">
 *      <select class="js-submit-on-change" name="path">...</select>
 *      <noscript><button type="submit">Show</button></noscript>
 *    </form>
 */

import { observe } from 'selector-observer';

observe('.js-submit-on-change', {
  constructor: HTMLElement,
  add(el) {
    if (
      el instanceof HTMLSelectElement ||
      el instanceof HTMLInputElement ||
      el instanceof HTMLTextAreaElement
    ) {
      el.addEventListener('change', () => el.form?.requestSubmit());
    }
  },
});
